import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  FETCH_ACTIVE_QUESTIONS: 'FETCH_ACTIVE_QUESTIONS',
  FETCH_ACTIVE_QUESTIONS_SUCCESS: 'FETCH_ACTIVE_QUESTIONS_SUCCESS',
  FETCH_ACTIVE_QUESTIONS_FAILED: 'FETCH_ACTIVE_QUESTIONS_FAILED',

  CANCEL_QUESTION: 'CANCEL_QUESTION',
  CANCEL_QUESTION_SUCCESS: 'CANCEL_QUESTION_SUCCESS',
  CANCEL_QUESTION_FAILURE: 'CANCEL_QUESTION_FAILURE',

  FETCH_NON_LOGIN_QUESTIONS: 'FETCH_NON_LOGIN_QUESTIONS',
  FETCH_NON_LOGIN_QUESTIONS_SUCCESS: 'FETCH_NON_LOGIN_QUESTIONS_SUCCESS',
  FETCH_NON_LOGIN_QUESTIONS_FAILED: 'FETCH_NON_LOGIN_QUESTIONS_FAILED',

  CLEAN_QUESTIONS: 'CLEAN_QUESTIONS',
};

export const {
  fetchActiveQuestions,
  fetchActiveQuestionsSuccess,
  fetchActiveQuestionsFailed,
  cancelQuestion,
  cancelQuestionSuccess,
  cancelQuestionFailure,
  fetchNonLoginQuestions,
  fetchNonLoginQuestionsSuccess,
  fetchNonLoginQuestionsFailed,
  cleanQuestions,
} = createActions(
  {
    [types.FETCH_ACTIVE_QUESTIONS]: (userId) => ({ userId }),
    [types.FETCH_ACTIVE_QUESTIONS_SUCCESS]: ({
      questions,
      currentPage,
      count,
      hasUnread,
    }) => ({
      questions,
      count,
      hasUnread,
      currentPage,
    }),
    [types.FETCH_ACTIVE_QUESTIONS_FAILED]: (errorMessage) => ({ errorMessage }),
    [types.CANCEL_QUESTION]: ({ lang, userId, questionId }) => ({
      lang,
      userId,
      questionId,
    }),
    [types.CANCEL_QUESTION_FAILURE]: (errorMessage) => ({ errorMessage }),
    [types.CANCEL_QUESTION_SUCCESS]: (questionId) => ({ questionId }),
    [types.FETCH_NON_LOGIN_QUESTIONS]: (questionId) => ({ questionId }),
    [types.FETCH_NON_LOGIN_QUESTIONS_SUCCESS]: ({ questions, count }) => ({
      questions,
      count,
    }),
    [types.FETCH_NON_LOGIN_QUESTIONS_FAILED]: (errorMessage) => ({
      errorMessage,
    }),
  },
  types.CLEAN_QUESTIONS
);

export const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
  nonLoginQuestionId: 0,
  questions: [],
  currentPage: 0,
  count: 0,
  hasUnread: false,
  errorMessage: '',
};

const reducer = handleActions(
  {
    [types.FETCH_ACTIVE_QUESTIONS]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.FETCH_ACTIVE_QUESTIONS_SUCCESS]: (state, action) => {
      const { questions, count, hasUnread, currentPage } = action.payload;

      return {
        ...state,
        loadingStatus: loadingState.READY,
        questions,
        count,
        hasUnread,
        currentPage,
      };
    },
    [types.FETCH_ACTIVE_QUESTIONS_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.CANCEL_QUESTION]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.CANCEL_QUESTION_SUCCESS]: (state, action) => {
      const { questionId } = action.payload;
      const activeQuestions = state.questions.filter(
        (q) => q.id !== questionId
      );

      return {
        ...state,
        loadingStatus: loadingState.READY,
        questions: activeQuestions,
      };
    },
    [types.CANCEL_QUESTION_FAILURE]: (state) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
    }),
    [types.FETCH_NON_LOGIN_QUESTIONS]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.FETCH_NON_LOGIN_QUESTIONS_SUCCESS]: (state, action) => {
      const { questions, count } = action.payload;

      return {
        ...state,
        loadingStatus: loadingState.READY,
        questions,
        count,
      };
    },
    [types.FETCH_NON_LOGIN_QUESTIONS_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.CLEAN_QUESTIONS]: (state) => ({
      ...state,
      questions: [],
      currentPage: 0,
      count: 0,
      hasUnread: false,
      errorMessage: '',
    }),
  },
  INIT_STATE
);

export default reducer;
export const getActiveQuestions = (state) => state.questions.activeQuestions;
export const getNonLoginQuestionId = (state) =>
  state.questions.activeQuestions.nonLoginQuestionId;
export const getActiveQuestionsCount = createSelector(
  getActiveQuestions,
  (activeQuestions) => activeQuestions.count
);
export const getActiveQuestionsHasUnread = createSelector(
  getActiveQuestions,
  (activeQuestions) => activeQuestions.hasUnread
);
export const getActiveQuestionsList = createSelector(
  getActiveQuestions,
  (activeQuestions) => activeQuestions.questions
);



// WEBPACK FOOTER //
// ./src/scenes/Home/services/redux/activeQuestions.js